import ApiBase from 'Services/Api/ApiBase';

class Groups extends ApiBase {
    route = '/admin/groups';
}

export default new Groups();
